import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './context/auth';
import { APIProvider } from './context/api';
import { SocialProvider } from './context/social';
import { AdminProvider } from './context/admin';
import { SelectedVideosProvider } from './context/selected-videos';

// IMPORTANT: BrowserRouter wraps the data providers (not the other way around).
// SocialProvider clears OAuth callback params from the URL with useNavigate(),
// which requires it to live inside the Router context. Previously the Router
// was inside App and SocialProvider called window.history.replaceState directly,
// which silently desynced react-router's internal pathname from the actual URL
// and broke every subsequent navigate() for the rest of the session.
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <AuthProvider>
      <APIProvider>
        <SocialProvider>
          <AdminProvider>
            <SelectedVideosProvider>
              <React.StrictMode>
                <App />
              </React.StrictMode>
            </SelectedVideosProvider>
          </AdminProvider>
        </SocialProvider>
      </APIProvider>
    </AuthProvider>
  </BrowserRouter>
);
